import { render } from "./ReferenceInfoTable.vue?vue&type=template&id=0b0cdc9a&scoped=true"
import script from "./ReferenceInfoTable.vue?vue&type=script&lang=js"
export * from "./ReferenceInfoTable.vue?vue&type=script&lang=js"

import "./ReferenceInfoTable.vue?vue&type=style&index=0&id=0b0cdc9a&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0cdc9a"]])

export default __exports__